import axios from "axios";

export const getApiExperiences = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/mobile/experiences`);
        const experiences = response.data;
        return { success: true, error: false, data: experiences };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiExperiencesFull = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/experiences`);
        const experiences = response.data.data;
        return { success: true, error: false, data: experiences };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiPointsOfInterest = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/points-of-interest`);
        const pointsOfInterest = response.data;
        return { success: true, error: false, data: pointsOfInterest };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiExperience = async (experienceId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/experiences/${experienceId}`);
        const experience = response.data;
        return { success: true, error: false, data: experience };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiPointOfInterest = async (pointOfInterestId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/points-of-interest/${pointOfInterestId}`);
        const pointOfInterest = response.data;
        return { success: true, error: false, data: pointOfInterest };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiPointsOfInterestsOfExperience = async (experienceId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/experiences/${experienceId}/points-of-interest`);
        const pointsOfInterest = response.data;
        return { success: true, error: false, data: pointsOfInterest };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiReviewsOfExperience = async (experienceId, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/experiences/${experienceId}/reviews`, config);
        const reviews = response.data;
        return { success: true, error: false, data: reviews };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiExperiencesOfPointOfInterest = async (pointOfInterestId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/points-of-interest/${pointOfInterestId}/experiences`);
        const experiences = response.data;
        return { success: true, error: false, data: experiences };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiTags = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/tags`);
        const tags = response.data.data;
        return { success: true, error: false, data: tags };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiExperienceCategories = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/experience-categories`);
        const categories = response.data.data;
        return { success: true, error: false, data: categories };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiPOICategories = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/point-of-interest-categories`);
        const categories = response.data.data;
        return { success: true, error: false, data: categories };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiExperiencesOfUser = async (userId, token) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/users/${userId}/experiences`, config);
        const experiences = response.data.data;
        return { success: true, error: false, data: experiences };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiPointOfInterestOfUser = async (userId, token) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/users/${userId}/points-of-interest`, config);
        const pointsOfInterest = response.data.data;
        return { success: true, error: false, data: pointsOfInterest };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiFavoriteExperiencesOfUser = async (userId, token) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/users/${userId}/favorite-experiences`, config);
        const experiences = response.data.data;
        return { success: true, error: false, data: experiences };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiReviewsOfExperiencesOfUser = async (userId, token) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/users/${userId}/experiences-reviews`, config);
        const reviews = response.data.data;
        return { success: true, error: false, data: reviews };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiReviewsOfUser = async (userId, token) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/users/${userId}/reviews`, config);
        const reviews = response.data.data;
        return { success: true, error: false, data: reviews };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiNotificationsOfUser = async (userId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/mobile/notifications?user_id=${userId}`);
        const notifications = response.data;
        return { success: true, error: false, data: notifications };
    } catch (error) {
        return { success: false, error: true };
    }
};

export const getApiStations = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/web/stations`);
        const stations = response.data.data;
        return { success: true, error: false, data: stations };
    } catch (error) {
        return { success: false, error: true };
    }
};
